import { Component, OnDestroy, OnInit } from '@angular/core';
import { Sensor, excludedSensorTypes, IValue, ApplianceTypes } from 'src/app/models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { Zone } from 'src/app/models/zone';
import { Appliance } from 'src/app/models/appliance';
import { DataService } from 'src/app/services/data.service';
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ApiService } from "src/app/services/api.service";
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { ZoneService } from '../../../services/zone.service';
import { MatDialog } from '@angular/material/dialog';
import { UpdateDialogComponent } from '../../clients/update-dialog/update-dialog.component';
import { AddDialogComponent } from'../../clients/add-dialog/add-dialog.component';

export interface Category {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-cycles',
  templateUrl: './cycles.component.html',
  styleUrls: ['./cycles.component.less']
})
export class CyclesComponent implements OnInit, OnDestroy {
  cycles: any | null = null;
  filteredCycles: any | null = null;
  filterMode: string = 'all'
  zone: any;
  currentCompany: any = null
  currentCompanyId: string | null = null
  // appliances: Appliance[] = [];
  // sensors: Sensor[] = [];
  // categories: Category[] = [];
  subscription: Subscription;
  constructor(private dataService: DataService,
    private socketService: SocketIoService,
    private _api: ApiService,
    public authService: AuthService,
    public dialog: MatDialog,
    private zoneService: ZoneService,) {

    this.dataService.sharedZone$.pipe(take(1)).subscribe(zone => {
      if (zone === undefined) {
        return;
      }
      this.zone = zone;
      this.currentCompany = this.zone.company.name
      this.currentCompanyId = this.zone.company._id
    })

  }

  ngOnInit(): void {
    this.getCycles();
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  getCycles(){
    let zones = []
    zones.push(this.zone.id)
    this._api.post<any>(`/cycles`, {zones: zones}).subscribe(resp => {
        this.cycles = resp.cycles;
        this.cycles.forEach(cycle=>{
          cycle.dates.start = moment(cycle.dates.start).format('MMMM Do YYYY, h:mm:ss a')
          if(cycle.dates.end){
            cycle.dates.end = moment(cycle.dates.end).format('MMMM Do YYYY, h:mm:ss a')
          }
        })
        this.filterCycles(this.filterMode)
    }, err => {
        alert(err.message);
    });
  }

  filterCycles(filter){
    this.filterMode = filter
    if(filter === 'all'){
      this.filteredCycles = this.cycles
    }
    if(filter === 'active'){
      this.filteredCycles = this.cycles.filter(cycle => cycle.currentState.state !== 'End')
    }
    if(filter === 'inactive'){
      this.filteredCycles = this.cycles.filter(cycle => cycle.currentState.state === 'End')
    }
  }

  addNew(type: string){
    let title = type[0].toUpperCase() + type.slice(1)
    let data: any = {
        type: type,
        company: this.currentCompanyId,
        title: title,
        name: '',
        zone: this.zone,
        function: (item) => this.add(type, item)
      }
    
    // if(type === 'sensor' || type === 'cycle'){
    //     data = {...data, }
    // }
    
    const dialogRef = this.dialog.open(AddDialogComponent, {
        disableClose: true,
        data: data
        
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === undefined) return;
        setTimeout(() => result.name);
        this.getCycles();
      });
}

add(type: string, data: any) {
  return this._api.post<any>(`/zone/${data.zone}/${type}`,
  {
    strainName: data.name,
    state: data.currentState,
    grow: {plantsQuantity: data.plantsQuantity},
    // plantsQuantity: data.grow.plantsQuantity,
    cycleTimes: data.cycleTimes,
    isAllSensors: data.isAllSensors,
    sensors: data.sensors,
    harvest: data.harvest ? data.harvest : {}
  });
}

  editCycle(cycle){
    const dialogRef = this.dialog.open(UpdateDialogComponent, {
      disableClose: true,
      data: {
        type: 'cycle',
        title: 'Cycle',
        name: cycle,
        function: (cycle) => this.updateCycle('cycle', cycle)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => cycle.name = result.name);
      this.getCycles();
    });
  }

  updateCycle(type: string, cycle: any) {
    let state: any = { state: cycle.data.name.currentState.state }
    if (cycle.name.currentState.state === 'Custom') {
      state = { state: cycle.data.customState}
    }
    if(cycle.data.name.zoneName._id){
      state = {...state, zone: cycle.data.name.zoneName._id}
    }
    if(cycle.data.name.grow.plantsQuantity){
      state = {...state, plantsQuantity: cycle.data.name.grow.plantsQuantity}
    }
    if(cycle.data.name.cycleTimes){
      state = {...state, cycleTimes: cycle.data.name.cycleTimes}
    }
    if(cycle.data.name.sensors){
      state = {...state, sensors: cycle.data.name.sensors, isAllSensors: cycle.data.name.isAllSensors}
    }
    return this._api.put<any>(`/zone/${cycle.data.name.zoneName._id}/cycle/${cycle.data.name.id}`, state);
}

  endCycle(cycle){
    this.zoneService.updateCycle(cycle.zone, cycle.id, { state: null }).subscribe(result => {
      this.getCycles();
    })
  }

  deleteCycle(cycle){
    this.zoneService.dalateCycle(cycle.zone, cycle.id).subscribe(result => {
      this.getCycles();
    })
  }

  updateCurrentZone(zone: Zone) {
    this.dataService.updateZone(zone);
  }

}
